define("shared/utils/formatters/ig-post-from-dynamo", ["exports", "later/models/ig-post"], function (_exports, _igPost) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/models/ig-post"eaimeta@70e063a35619d71f
  /**
   * Converts a raw dynamo post into an igPost with analytics
   *
   */
  function createIgPostFromDynamo(obj, socialProfile) {
    const impressions = obj.carousel_album_impressions || obj.impressions;
    const views = obj.carousel_album_views || obj.views;
    const reach = obj.carousel_album_reach || obj.reach;
    const savedCount = obj.carousel_album_saved || obj.saved;
    const shareCount = obj.shares || obj.share_count;
    const videoViews = obj.carousel_album_video_views || obj.video_views || obj.total_plays;
    const engagements = obj.carousel_album_engagement || calculateEngagements(obj);
    const attrs = {
      timeCollected: Date.now(),
      hasMedia: true,
      socialProfile,
      id: obj.id,
      createdTime: Number(obj.created_time),
      type: obj.type,
      followersOnPost: obj.followers_on_post,
      isStory: false,
      isCarousel: obj.type === 'carousel',
      isDeleted: obj.is_deleted,
      linkinbioPostId: obj.linkinbio_post_id,
      linkinbioMediaId: obj.linkinbio_media_id,
      thumbUrl: obj.permanent_image_url || obj.image_square_url,
      imageUrl: obj.permanent_image_url || obj.image_medium_url || obj.image_square_url,
      engagement: convertToNumberOrUndefined(obj.engagement_rate),
      engagements: convertToNumberOrUndefined(engagements),
      impressions: convertToNumberOrUndefined(impressions),
      views: convertToNumberOrUndefined(views),
      reach: convertToNumberOrUndefined(reach),
      savedCount: convertToNumberOrUndefined(savedCount),
      videoViews: convertToNumberOrUndefined(videoViews),
      shareCount: convertToNumberOrUndefined(shareCount),
      commentCount: convertToNumberOrUndefined(obj.comment_count),
      likeCount: convertToNumberOrUndefined(obj.like_count),
      followersCount: obj.followers_on_post,
      standardResUrl: obj.image_medium_url,
      instagramLink: obj.link,
      caption: obj.caption,
      scheduledPost: obj.scheduledPost
    };
    return _igPost.DynamoIgPost.create(attrs);
  }
  function calculateEngagements(obj) {
    const likes = obj.like_count;
    const comments = obj.comment_count;
    const shares = obj.share_count;
    const saves = obj.saved;
    if (likes === undefined && comments === undefined && shares === undefined && saves === undefined) {
      return undefined;
    }
    return (likes ?? 0) + (comments ?? 0) + (shares ?? 0) + (saves ?? 0);
  }
  function convertToNumberOrUndefined(input) {
    return input ? Number(input) : undefined;
  }
  var _default = _exports.default = createIgPostFromDynamo;
});